export default __webpack_public_path__ + "static/media/APPLE_STORE_BADGE_EN.5fa8a709.svg";